import { c as _c } from "react/compiler-runtime";
import ControlledTextField from "@components/hookform/TextField";
import { Control } from "react-hook-form";
import { FieldValues, FormFieldDefinition } from "./interfaces";
export interface InputFieldProps<T extends FieldValues> {
  control: Control<T>;
  fieldDefinition: FormFieldDefinition<T>;
  autoFocus?: boolean;
}
const InputField = t0 => {
  const $ = _c(12);
  const {
    control,
    fieldDefinition,
    autoFocus
  } = t0;
  const t1 = fieldDefinition.as === "textarea";
  let t2;
  if ($[0] !== autoFocus || $[1] !== control || $[2] !== fieldDefinition.info || $[3] !== fieldDefinition.inputMode || $[4] !== fieldDefinition.label || $[5] !== fieldDefinition.name || $[6] !== fieldDefinition.placeholder || $[7] !== fieldDefinition.rules || $[8] !== fieldDefinition.suffix || $[9] !== fieldDefinition.type || $[10] !== t1) {
    t2 = <div className="flex relative max-w-[360px]"><div className="w-full"><ControlledTextField autoFocus={autoFocus} rules={fieldDefinition.rules} control={control} name={fieldDefinition.name} label={fieldDefinition.label} info={fieldDefinition.info} suffix={fieldDefinition.suffix} data-testid={fieldDefinition.name} textarea={t1} type={fieldDefinition.type} placeholder={fieldDefinition.placeholder} inputMode={fieldDefinition.inputMode} /></div></div>;
    $[0] = autoFocus;
    $[1] = control;
    $[2] = fieldDefinition.info;
    $[3] = fieldDefinition.inputMode;
    $[4] = fieldDefinition.label;
    $[5] = fieldDefinition.name;
    $[6] = fieldDefinition.placeholder;
    $[7] = fieldDefinition.rules;
    $[8] = fieldDefinition.suffix;
    $[9] = fieldDefinition.type;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
export default InputField;